export const getCartProductsDetailsFromJSON = (dispatch) => {
  var response = require('../containers/Cart/sampleCartProductDetailsJson.json');
  dispatch({ type: 'CARTPRODUCTSDETAILSFROMJSON', value: response.data.prodAccessoryList, subTotal: response.data.Subtotal, total: response.data.Total, shippingcrg: response.data.Shippingcharge, tax: response.data.Tax });
  return response;
}

export const showCart = (hideCart, dispatch) => {
  var response = hideCart
  setTimeout(() => {
    let setFocusToClsBtn=document.getElementById("cartClsBtn");
    if(setFocusToClsBtn){
      setFocusToClsBtn.focus();
    }
   },0);
  dispatch({ type: 'SHOWCART', value: !response });
  if(response && document.getElementById("cartBtn")){
    document.getElementById("cartBtn").setAttribute("aria-expanded",!response);
    setTimeout(() => {
      let setFocusToCartBtn=document.getElementById("cartBtn");
      if(setFocusToCartBtn){
        setFocusToCartBtn.focus();
      }
     },0);
  } else if(!response) {
    document.getElementById("cartBtn").setAttribute("aria-expanded","true");
  }
  return response;
}

